var React = require("react");
const PropTypes = require('prop-types');

var Radio = function (props) {
	var classes = "radio";
	if (props.disabled === true) {
		classes += " disabled";
	}

	var fullLabel = props.description;
	if (props.extendedDescription) {
		fullLabel += ', ' + props.extendedDescription;
	}

	return (
		<div className={classes}>
			<label htmlFor={props.name + props.id}>
				<input
					onChange={props.onClick}
					type="radio"
					name={props.name}
					id={props.name + props.id}
					value={props.id}
					checked={props.checked}
					disabled={(props.disabled === true)}
					aria-label={fullLabel}
				/>
				{props.description}
				{props.extendedDescription
					&& (
						<p className="radio__extended-description">
							{props.extendedDescription}
						</p>
					)
				}
			</label>

		</div>
	);
};

Radio.propTypes = {
	id: PropTypes.number.isRequired,
	name:  PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	extendedDescription: PropTypes.string,
	checked: PropTypes.bool.isRequired,
	onClick: PropTypes.func.isRequired,
	disabled: PropTypes.bool
};

Radio.defaultPropTypes = {
	disabled: false
};

module.exports = Radio;
